<script setup>
import { Link } from '@inertiajs/vue3'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import { WrenchScrewdriverIcon, FireIcon, BeakerIcon, CheckIcon } from '@heroicons/vue/24/solid'
import {
    plumbing,
    heating,
    gas,
    maintenance,
    boilerReplacement,
    heatPumps,
} from '@/actions/App/Http/Controllers/ServiceController'

const services = [
    {
        name: 'Vodoinstalace',
        description:
            'Profesionální instalatérské služby pro váš domov i firmu. Od oprav kapajícího kohoutku po kompletní instalace vodovodních systémů.',
        icon: BeakerIcon,
        route: plumbing(),
        features: ['Instalace rozvodů', 'Opravy a servis', 'Montáž sanitární techniky', 'Havarijní služba'],
    },
    {
        name: 'Topenářství',
        description:
            'Spolehlivé topenářské služby pro váš komfort. Od návrhu a instalace topných systémů po servis a opravy kotlů.',
        icon: FireIcon,
        route: heating(),
        features: ['Instalace topných systémů', 'Opravy a havarijní služba'],
    },
    {
        name: 'Plynoinstalace',
        description:
            'Bezpečné a certifikované plynoinstalační služby. Od instalace rozvodů a připojení spotřebičů po revize a havarijní opravy.',
        icon: WrenchScrewdriverIcon,
        route: gas(),
        features: ['Instalace rozvodů', 'Připojení spotřebičů', 'Opravy a havarijní zásahy'],
    },
    {
        name: 'Servis / Sezonní údržba',
        description:
            'Servis a opravy topných systémů a kotlů. Sezónní kontroly pro bezpečný, úsporný a spolehlivý provoz.',
        icon: WrenchScrewdriverIcon,
        route: maintenance(),
        features: ['Servis a opravy', 'Sezónní kontroly topných zařízení'],
    },
    {
        name: 'Výměna kotlů',
        description:
            'Odborná výměna a instalace kotlů všech typů. Od plynových a elektrických kotlů po kotle na pevná paliva.',
        icon: FireIcon,
        route: boilerReplacement(),
        features: ['Plynové kotle', 'Elektrokotle', 'Kotle na pevná paliva'],
    },
    {
        name: 'Tepelná čerpadla',
        description:
            'Moderní a úsporné vytápění s nízkými provozními náklady. Návrh, instalace a servis tepelných čerpadel.',
        icon: BeakerIcon,
        route: heatPumps(),
        features: ['Návrh řešení na míru', 'Kompletní instalace', 'Servis a poradenství'],
    },
]
</script>

<template>
    <section>
        <div class="mx-auto max-w-2xl text-center">
            <p class="text-brand-primary text-sm font-semibold tracking-wider uppercase">Naše služby</p>
            <h2 class="heading-2 mt-2">Kompletní servis pro váš domov a firmu</h2>
            <p class="paragraph mt-4">
                Od roku 1995 se věnujeme poskytování služeb v oblasti vodoinstalace, topenářství a plynu. Realizovali
                jsme řadu velkých i malých projektů. Naše působnost pokrývá celý region jižní Moravy. Nabízíme nejen
                instalatérské služby, ale i opravy a servis plynových zařízení.
            </p>
        </div>

        <div class="mt-16 grid auto-rows-fr grid-cols-1 gap-8 lg:grid-cols-3">
            <div
                v-for="service in services"
                :key="service.name"
                class="group hover:ring-brand-primary/40 relative flex flex-col justify-between overflow-hidden rounded-4xl bg-gray-50 ring-1 shadow-gray-100 ring-gray-100 transition-all duration-300 hover:bg-white hover:shadow-lg"
            >
                <div class="flex-1 p-8">
                    <div
                        class="bg-brand-primary/10 text-brand-primary mb-6 inline-flex size-14 items-center justify-center rounded-xl transition-colors"
                    >
                        <component
                            :is="service.icon"
                            class="size-7"
                        />
                    </div>

                    <h3 class="text-xl font-semibold text-gray-900">{{ service.name }}</h3>
                    <p class="mt-3 text-gray-600">{{ service.description }}</p>

                    <ul class="mt-6 space-y-2">
                        <li
                            v-for="feature in service.features"
                            :key="feature"
                            class="flex items-center text-sm text-gray-600"
                        >
                            <CheckIcon class="text-brand-primary mr-2 size-4 shrink-0" />
                            {{ feature }}
                        </li>
                    </ul>
                </div>

                <div class="p-2">
                    <div
                        class="bg-brand-primary inline-flex w-full items-center rounded-full px-4 py-4 text-sm font-semibold text-white"
                    >
                        Více informací
                        <ArrowRightIcon class="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </div>
                </div>
                <Link
                    :href="service.route"
                    class="absolute inset-0"
                >
                    <span class="sr-only">{{ service.name }} - více informací</span>
                </Link>
            </div>
        </div>
    </section>
</template>
